import store from '@/store';
import H_file from '@/helpers/file';
import H_time from '@/helpers/time';
import H_common from '@/helpers/common';
import H_factoryTag from '@/helpers/factoryTag';

export default {
  setIndex(rawDataList) {
    return rawDataList.map(({
      factory_tags,
      id,
      name,
      updated_at,
      meeting_template_type,
    }) => {
      return {
        id,
        name: {
          text: name,
          chips: H_common.setFactoryTagsInDataTable(factory_tags),
        },
        updatedAt: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
        type: meeting_template_type.name,
      };
    });
  },
  setShow(rawData) {
    const {
      attach,
      factory_tags,
      id,
      meeting_template_items,
      meeting_template_type,
      name,
      remark,
      updated_at,
      updated_user,
      is_used,
    } = rawData;
    return {
      id,
      name,
      remark,
      updatedAt: H_time.getDateDashFormat(updated_at, 'YYYY-MM-DD HH:mm:ss'),
      updatedUser: updated_user,
      factoryTags: H_factoryTag.setShowInModule(factory_tags),
      attach: attach ? H_file.setShowInModule([attach]) : [],
      type: meeting_template_type.name,
      variables: this.setMeetingTemplateItemsShowInModule(meeting_template_items),
      isUsed: is_used === 1,
    };
  },
  setTemplateFieldItems(res) {
    return res.map(({
      id,
      name,
      value,
    }) => {
      return {
        id,
        textLabel: name,
        value,
      };
    });
  },
  setTemplateTypeItems(res) {
    return res.map(({
      id,
      name,
      value,
    }) => {
      return {
        id,
        textLabel: name,
        value,
      };
    });
  },
  setSubmitCreateData(createData) {
    const {
      template,
      variables,
      name,
      type,
      factoryTags,
      remark,
    } = createData;
    return {
      name,
      meeting_template_type: type,
      remark,
      factory_tags: factoryTags[0],
      attach: H_file.setSubmitInModule(template)[0],
      meeting_template_items: this.setSubmitMeetingTemplateItems(variables),
    }
  },
  setSubmitUpdateData(updateData) {
    const {
      template,
      variables,
      name,
      type,
      factoryTags,
      remark,
    } = updateData;
    return {
      name,
      meeting_template_type: type,
      remark,
      factory_tags: factoryTags[0],
      attach: H_file.setSubmitInModule(template)[0],
      meeting_template_items: this.setSubmitMeetingTemplateItems(variables),
    }
  },
  setSubmitMeetingTemplateItems(variables) {
    const factoryId = store.state.app.factory.id;
    return variables.map(({
      id,
      sequence,
      name,
      value,
      field,
      has_line_break,
    }) => {
      const result = {
        sequence,
        name,
        value,
        factory: factoryId,
        meeting_template_field: field,
        has_line_break,
      };
      if (id) result.id = id;
      return result;
    });
  },
  setMeetingTemplateItemsShowInModule(rawDataList) {
    return rawDataList.map(({
      id,
      name,
      value,
      meeting_template_field,
    }) => {
      const isValueTop = value === '${top}';
      return {
        id,
        mark: value,
        name: isValueTop ? '' : name,
        field: isValueTop ? '' : meeting_template_field?.name ?? '',
        copy: {
          icon: 'icon-copy',
          color: 'blue',
          tooltipText: '複製',
        }
      };
    });
  },
  setUpdate(rawData) {
    const {
      attach,
      factory_tags,
      id,
      meeting_template_items,
      meeting_template_type,
      name,
      remark,
      is_used,
    } = rawData;
    return {
      id,
      name,
      remark,
      type: meeting_template_type.id,
      template: attach ? H_file.setShowInModule([attach]) : [],
      factoryTags: [factory_tags.map(tag => tag.id)],
      variables: this.setMeetingTemplateItemsUpdateInModule(meeting_template_items),
      isUsed: is_used === 1,
    }
  },
  setMeetingTemplateItemsUpdateInModule(rawDataList) {
    return rawDataList.map(({
      id,
      name,
      value,
      meeting_template_field,
      sequence,
      has_line_break,
    }) => {
      return {
        id,
        sequence,
        name,
        value,
        field: meeting_template_field ? meeting_template_field.id : '',
        has_line_break,
      };
    });
  },
  setTemplateDropdownList(rawDataList) {
    return rawDataList.map(({
      id,
      name,
    }) => {
      return {
        id,
        textLabel: name,
        value: id,
      };
    });
  },
  compareFields(newFields, oldFields) {
    const oldFieldsMap = new Map(oldFields.map(oldField => [oldField.value, oldField]));

    return newFields.map(newField => {
      const sameValueOldField = oldFieldsMap.get(newField.value);
      if (!sameValueOldField) return newField;
      const { id, field } = sameValueOldField;
      return { id, ...newField, field };
    });
  },
  setFieldsFromFile(rawDataList, templateFieldItems) {
    return rawDataList.map(rawData => {
      if (rawData.field !== null && rawData.field !== undefined) return rawData;
      const matchItem = this.getExactMatchedTemplateFieldItem(rawData, templateFieldItems);
      return {
        ...rawData,
        field: matchItem ? matchItem.id : null,
      };
    });
  },
  getExactMatchedTemplateFieldItem(rawData, templateFieldItems) {
    const normalizedTemplateFieldItems = templateFieldItems.map(item => ({
      item,
      targetTextList: [item?.textLabel, item?.value].map(text => this.normalizeCompactText(text)),
    }));

    const nameMatchedItem = this.getMatchedTemplateFieldItemBySourceText(rawData?.name, normalizedTemplateFieldItems);
    if (nameMatchedItem) return nameMatchedItem;

    return this.getMatchedTemplateFieldItemBySourceText(rawData?.value, normalizedTemplateFieldItems);
  },
  getMatchedTemplateFieldItemBySourceText(sourceText, normalizedTemplateFieldItems) {
    const normalizedSourceText = this.normalizeCompactText(sourceText);
    if (!normalizedSourceText) return null;

    const matchedData = normalizedTemplateFieldItems.find(({ targetTextList }) => {
      return targetTextList.some(targetText => targetText && normalizedSourceText === targetText);
    });

    return matchedData ? matchedData.item : null;
  },
  normalizeCompactText(text) {
    return String(text || '')
      .normalize('NFKC')
      .toLowerCase()
      .trim()
      .replace(/[^\p{L}\p{N}]+/gu, '');
  }
};
